module.exports = __webpack_public_path__ + "img/mail.9b7c26b0.svg";